import { ExternalLinkAltIcon } from '@patternfly/react-icons'

import './external-link.css';

interface ExternalLinkProps {
    /** The URL for this external link */
    url: string;
    className?: string;
    /** Show "external link" icon next to the link. Defaults to true. */
    showIcon?: boolean;
    /** Uses an "unset" style for the link, basically removing all default styling. Defaults to false. */
    noStyles?: boolean;
}

/** Represents an external link in UI that opens in a new tab/window. */
const ExternalLink = (props: React.PropsWithChildren<ExternalLinkProps>) => {
    const { url, children, className = '', showIcon = true, noStyles = false } = props;

    const finalClassName = noStyles ? `external-link-no-styles ${className}`.trim() : className;

    return (
        <span>
            <a href={url} target="_blank" rel="noopener noreferrer" className={finalClassName}>{children}
                {showIcon && (
                    <span className="external-link-icon">
                        <ExternalLinkAltIcon />
                    </span>
                )}
            </a>
        </span>
    );
}

export default ExternalLink;
